"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var redux_1 = require("redux");

var enums_1 = require("../../../enums");

var store_1 = require("../../../store");

var functions_1 = require("../functions");

var ResendCodeLink = react_1.default.memo(function (_a) {
  var username = _a.username,
      initiateResetPasswordFlow = _a.initiateResetPasswordFlow;
  var payload = functions_1.validateAndPrepareResetPasswordModel(username);
  return react_1.default.createElement(components_lib_1.Button, {
    type: components_lib_1.ButtonTypeEnum.link,
    text: enums_1.FieldLabels.forgotPasswordResendCode,
    uppercase: false,
    onPress: function onPress() {
      return initiateResetPasswordFlow(payload);
    }
  });
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    username: store_1.authPasswordResetUsernameSelector(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    initiateResetPasswordFlow: redux_1.bindActionCreators(store_1.initiateResetPasswordFlowActionCreator, dispatch)
  };
};

var connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
exports.default = connector(ResendCodeLink);